import React, { useState, useEffect } from 'react';

import { Input, formatDisplayValue } from '../TowerEditor';
import { useDispatch } from 'react-redux';
import { changeBody, summaryWeight } from '../../../modules/tower/towerWriteSlice';

const UserInputForm = ({ userInput }) => {
    const [newUserInput, setNewUserInput] = useState(userInput || {});

    const dispatch = useDispatch();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewUserInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    /* 내부 계산 */
    useEffect(() => {
        const weight = newUserInput.qty * newUserInput.unitWeight;

        setNewUserInput((prev) => ({
            ...prev,
            weight,
        }));
    }, [newUserInput.qty, newUserInput.unitWeight]);

    /* 리덕스에 weightSum 쓰기 */
    useEffect(() => {
        dispatch(
            summaryWeight({
                key: 'userInput',
                value: newUserInput.weight || 0,    // "|| 0"을 하지 않으면 undefined가 들어가서 다양한 에러가 발생한다.
            }),
        );
    }, [dispatch, newUserInput.weight]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        if (!newUserInput.weight) {
            return;
        }
        dispatch(
            changeBody({
                key: 'userInput',
                value: newUserInput,
            }),
        );
    }, [dispatch, newUserInput]);

    return (
        <>
            <tr>
                <td>User Input</td>
                <td colSpan={3} className="input-inside-td">
                    <Input
                        style={{ textAlign: 'left' }}
                        placeholder="상기에 없는 항목은 여기에 입력하세요."
                        name="description"
                        value={newUserInput.description}
                        onChange={handleChange}
                    />
                </td>
                <td className="input-inside-td">
                    <Input placeholder="수량" name="qty" value={newUserInput.qty} onChange={handleChange} />
                </td>
                <td className="input-inside-td">
                    <Input
                        style={{ textAlign: 'left' }}
                        placeholder="단위"
                        name="unit"
                        value={newUserInput.unit}
                        onChange={handleChange}
                    />
                </td>
                <td className="input-inside-td">
                    <Input
                        placeholder="단위중량"
                        name="unitWeight"
                        value={newUserInput.unitWeight}
                        onChange={handleChange}
                    />
                </td>
                <td className="right-align">{formatDisplayValue(newUserInput.weight)}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
        </>
    );
};

export default UserInputForm;
